<script>
import apiEndpoints from "@/services/apiEndpoints";
import CommonTableComponent from "@/components/table.vue";

export default {
  name: "Wastes",
  components: {
    CommonTableComponent
  },
  props: {},
  data() {
    return {
      isLoading: false,
      wasteOrService: {},
      data: [],
      dataSelected: [], // 選択した処理後廃棄物(累計)
      nowSelected: [], // 選択した処理後廃棄物(現在のポップアップ内)
      headers: [
        {
          text: "",
        },
        {
          text: "コード",
        },
        {
          text: "処理後廃棄物",
        }
      ],
    };
  },
  created() {
    // this.getData();
  },
  methods: {
    async getData() {
      // if (!this.wasteOrService || !this.wasteOrService.waste_or_service_by_work_order) {
      //   return;
      // }
      this.isLoading = true;
      // disposalSitesByWasteIdは不要になったため適当に値を詰めておく
      const disposalSitesByWasteId = 0;
      const url = apiEndpoints.list_waste_categories_after_treatment;
      const {status, data} = await this.$http.get(url, {disposalSitesByWasteId: disposalSitesByWasteId, wasteId : this.wasteOrService.waste_id});
      if (status) {
        this.data = data.result;
      }
      this.isLoading = false;
    },
    onClickRow(id) {
      const index = this.nowSelected.indexOf(id);
      if (index === -1) {
        this.nowSelected.push(id);
      } else {
        this.nowSelected.splice(index, 1);
      }
    },
    updateValue: function() {
      const listWastesSelected = this.filteredItems();
      this.$emit("dataSelected", listWastesSelected);
      this.nowSelected = []; // ポップアップ選択状態のクリア
      this.closeModal();
    },
    filteredItems() {
      this.nowSelected.forEach(selectedItem => {
        // 元の選択済みリストにポップアップで選択したものをマージ
        this.dataSelected.push(this.data.filter(item => selectedItem === item.id)[0].id);
      });

      let filtered = [];

      this.dataSelected.forEach(selectedItem => {
        // 選択済みリストのidの数だけ、マッチする処理後廃棄物を重複を許容して追加していく
        filtered.push(this.data.filter(item => selectedItem === item.id)[0]);
      });

      return filtered;
    },
    openModal(dataSelected, wasteOrService) {
      // jsonのwosByWOが入っている
      this.wasteOrService = wasteOrService;
      if (Array.isArray(dataSelected)) {
        this.dataSelected = dataSelected
      }
      this.$nextTick(() => this.$bvModal.show("modal-waste-treatment"))
    },
    closeModal() {
      this.$bvModal.hide("modal-waste-treatment");
    },
    modalHidden() {
      this.$emit("modalHidden");
    },
  },
  computed: {
  }
};
</script>
<template>
  <div class="d-xl-flex">
    <slot name="openBtn">

    </slot>
    <!-- modal area -->
    <b-modal
      title="処理後廃棄物一覧"
      size="xl"
      id="modal-waste-treatment"
      centered
      title-class="font-18"
      hide-footer
      scrollable
      @show="getData"
      @hidden="modalHidden"
    >
      <b-row class="mt-2">
        <b-overlay
          :show="isLoading"
          rounded
          opacity="0.6"
          spinner-small
          spinner-variant="primary"
          class="d-inline-block"
        >
          <div>
            <CommonTableComponent :height-class="`table-wrapper-500`">
              <thead class="table-light">
                <tr>
                  <th
                    v-for="(item, index) in headers"
                    :key="index"
                  >
                    {{ item.text }}
                  </th>
                </tr>
              </thead>
              <tbody>
                <template v-for="(item, index) in data">
                  <tr class="cursor-pointer" @click="onClickRow(item.id)">
                    <td class="sticky-column-1">
                      <b-form-checkbox
                        v-model="nowSelected"
                        :value="item.id"
                      ></b-form-checkbox>
                    </td>
                    <td class="sticky-column-2">
                      <span>{{ item.id }}</span>
                    </td>
                    <td class="sticky-column-3">
                      <span>{{ item.name_abbreviated }}</span>
                    </td>
                  </tr>
                </template>
                <template v-if="!data.length">
                  <tr>
                    <td :colspan="headers.length" class="text-center">
                      データなし。
                    </td>
                  </tr>
                </template>
              </tbody>
            </CommonTableComponent>
          </div>
          <div class="d-flex justify-content-end mt-3">
            <button
              size="xl"
              class="btn btn-primary waves-effect waves-light me-2"
              @click="updateValue"
            >
              <i class="fas fa-check"></i> {{ this.$lang.button.sure }}
            </button>
          </div>
        </b-overlay>
      </b-row>
    </b-modal>
  </div>
</template>

<style lang="scss" scoped>
table tr .cell-custom {
  padding: 0;
  border: 0;
  width: 50px;
  div {
    min-height: 20px;
  }
}
</style>
